export const checkIfRedoSurvey = (dates) => {
    const checkSurveyData = () => {
        let redo = false;
        if (dates?.length > 0) {
            localStorage.setItem("goal_ids", JSON.stringify([dates[0].goal1, dates[0].goal2, dates[0].goal3]));

            const first = new Date(dates[0].created_at);

            const latest = new Date(dates[dates.length - 1].created_at);

            const currDate = new Date();

            const a30_days = 1000 * 60 * 60 * 24 * 30;

            const monthsFirst = Math.floor(Number((currDate - first) / a30_days)) * 1;
            const monthsLatest = Math.floor(Number((currDate - latest) / a30_days)) * 1;

            if (monthsLatest > 0) {
                if (monthsFirst % 3 === 0) {
                    redo = {
                        val: true,
                        type: "full",
                    };
                } else {
                    redo = {
                        val: true,
                        type: "half",
                    };
                }
            }
        }
        return redo;
    };

    const currDate = new Date();

    const isSkipSurvey = localStorage.getItem("indi-skip-survey");
    const isRedoSurvey = localStorage.getItem("indi-redo-survey");

    let skipSurveyRedoDate = localStorage.getItem("indi-skip-survey-repeat-date");
    skipSurveyRedoDate = skipSurveyRedoDate ? new Date(skipSurveyRedoDate) : false;

    if (isRedoSurvey === null || (isRedoSurvey && !isSkipSurvey) || (isRedoSurvey && isSkipSurvey && currDate >= skipSurveyRedoDate)) {
        const redoSurvey = checkSurveyData();
        if (redoSurvey) {
            localStorage.setItem("indi-redo-survey", true);
            localStorage.setItem("indi-redo-type", redoSurvey.type);

            return redoSurvey;
        } else {
            return null;
        }
    } else {
        return null;
    }
};

export const checkImpactFrag = () => {
    const irclickid = localStorage.getItem("irclickid");
    const accessToken = localStorage.getItem("access-token");

    return irclickid && !accessToken;
};

export const checkIfUsingMobileApp = () => {
    const platform = localStorage.getItem("indi-platform");
    return platform && (platform === "ios-app" || platform === "android-app");
};

export const logoutAndRedirectMain = (navigate) => {
    const dev = localStorage.getItem("indi-device-type");
    const platform = localStorage.getItem("indi-platform");

    localStorage.clear();
    localStorage.setItem("indi-device-type", dev);
    localStorage.setItem("indi-platform", platform);

    navigate("/");
};
